<template>
  <f7-list
    class="route-instructions">
    <f7-list-item
      v-for="(i, j) in remaining"
      :key="j + '-' + i.total_distance"
      :title="i.text"
      @click="$emit('click', i)">
      <FlatIcon
        slot="media"
        :size="26"
        :name="icon(i.sign)" />
      <DistanceUnit
        v-if="!arrived"
        slot="after"
        :value="at(i.total_distance)"
        :decimals="at(i.total_distance) > 999 ? 1 : 0"
        best />
    </f7-list-item>
  </f7-list>
</template>

<script>
import { graphhopperIcons } from '@/services/graphhopper'
export default {
  name: 'RouteInstructions',
  props: {
    instructions: {
      type: Array,
      required: true
    },
    distance: {
      type: Number,
      default: 0
    }
  },
  computed: {
    formatData () {
      return this.instructions.reduce((acc, i) => {
        acc.distance = acc.distance + i.distance
        const inst = Object.assign({ total_distance: acc.distance }, i)
        acc.instructions.push(inst)
        return acc
      }, { distance: 0, instructions: [] })
    },
    remaining () {
      const instructions = this.formatData.instructions
      return this.arrived
        ? [ instructions[instructions.length - 1] ]
        : instructions.filter(i => i.total_distance >= this.distance)
    },
    arrived () {
      return this.distance >= this.formatData.distance
    }
  },
  methods: {
    icon (code) {
      return graphhopperIcons[code.toString()]
    },
    at (distance) {
      return distance - this.distance
    }
  }
}
</script>

<style lang="scss">
.route-instructions.list {
  .item-title {
    white-space: normal;
    overflow: visible;
    text-overflow: inherit;
  }
  li {
    cursor: pointer;
  }
}
</style>

<!-- [
  { distance: 32.899, heading: 117.12, sign: 0, interval: [0,1], text: 'Continue onto Brahestraße', time: 8459, street_name: 'Brahestraße' },
  { distance: 161.198, sign: 2, interval: [1,3], text: 'Turn right onto Kamminer Straße', time: 41450, street_name: 'Kamminer Straße' },
  { distance: 2047.776, sign: -2, interval: [3,22], text: 'Turn left onto Osnabrücker Straße', time: 245718, street_name: 'Osnabrücker Straße' },
  { distance: 92.123, sign: 2, interval: [22,24], text: 'Turn right onto Gotzkowskystraße', time: 11053, street_name: 'Gotzkowskystraße' },
  { distance: 1616.332, sign: -2, interval: [24,36], text: 'Turn left onto Levetzowstraße', time: 193948, street_name: 'Levetzowstraße' },
  { exit_number: 3, distance: 1979.36, sign: 6, exited: true, turn_angle: -5.06, interval: [36,51], text: 'At roundabout, take exit 3 onto Straße des 17. Juni, B 2, B 5', time: 222768, street_name: 'Straße des 17. Juni, B 2, B 5' },
  { distance: 194.651, sign: -2, interval: [51,60], text: 'Turn left onto Ebertstraße, B 2, B 5', time: 21897, street_name: 'Ebertstraße, B 2, B 5' },
  { distance: 238.291, sign: 2, interval: [60,62], text: 'Turn right onto Dorotheenstraße, B 5', time: 47658, street_name: 'Dorotheenstraße, B 5' },
  { distance: 194.261, sign: 2, interval: [62,64], text: 'Turn right onto Wilhelmstraße, B 5', time: 36325, street_name: 'Wilhelmstraße, B 5' },
  { distance: 2377.697, sign: -2, interval: [64,83], text: 'Turn left onto Unter den Linden, B 5', time: 276284, street_name: 'Unter den Linden, B 5' },
  { distance: 1223.038, sign: 2, interval: [83,92], text: 'Turn right onto Alexanderstraße, B 2, B 5', time: 137576, street_name: 'Alexanderstraße, B 2, B 5' },
  { exit_number: 2, distance: 1803.677, sign: 6, exited: true, turn_angle: 2.04, interval: [92,102], text:'At roundabout, take exit 2 onto Strausberger Platz, B 1, B 5', time: 202908, street_name: 'Strausberger Platz, B 1, B 5' },
  { distance: 574.834, sign: 2, interval: [102,103], text: 'Turn right onto Warschauer Straße, B 96a', time: 64667, street_name: 'Warschauer Straße, B 96a' },
  { distance: 381.153, sign: -2, interval: [103,105], text: 'Turn left onto Kopernikusstraße', time: 52773, street_name: 'Kopernikusstraße' },
  { distance: 66.239, sign: 2, interval: [105,108], text: 'Turn right onto Simplonstraße', time: 17032, street_name: 'Simplonstraße' },
  { distance: 72.969, sign: 2, interval: [108,109], text: 'Turn right onto Dirschauer Straße', time: 18763, street_name: 'Dirschauer Straße' },
  { distance: 0.0, sign: 4, last_heading: 196.30107018977134, interval: [109,109], text: 'Arrive at destination', time: 0, street_name: '' }
] -->
